export default __webpack_public_path__ + "static/media/2WF.74e1a407.png";